import React, {useState, useEffect} from 'react';
import Upload from "~/Components/Upload/Upload";
import {humanFileSize} from '~/helpers/utils';
import {ProgressBar} from 'react-bootstrap';
import {adminHttp} from "~/Admin/services/http";
import produce from "immer";
import deleteIcon from "~/assets/icons/delete.png";
import {connect} from "react-redux";
import ValidationError from "~/Components/Forms/ValidationError";

const AdminItineraryFileUploader = ({event, itinerary, onUploaded}) => {

    const [fileToUpload, setFileToUpload] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState(null);
    const [uploading, setUploading] = useState(false);

    const addFile = (file) => {
        setFileToUpload(file);
    }

    const removeFile = () => {

        setError('');
        setFileToUpload(null);
    }

    const fileUploaded = (file) => {

        const newList = produce(uploadedFiles, (draft) => {
            draft.push(file);
        });

        setUploadedFiles(newList);
    };

    const cancel = () => {
        setUploading(false);
        setFileToUpload(null);
        setError('');
    }

    const startUpload = () => {

        setUploading(true);

        let formData = new FormData();

        formData.append("file", fileToUpload);

        const onUploadProgress = (event) => {
            let newProgress = Math.round((100 * event.loaded) / event.total);
            setProgress(Math.max(newProgress, progress));
        }

        adminHttp.post("/events/" + event.id + "/itineraries/" + itinerary.id + '/documents', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress,
        }).then((response) => {

            if (onUploaded) {
                onUploaded(response.data);
            }

            cancel();

        }).catch((error) => {
            setProgress(0);
            setUploading(false);
            setError(error.response?.data);
        });
    }

    return (
        <div className="row">
            <div className="col-12">
                <Upload sendFiles={(files) => addFile(files[0])} />
                <ValidationError errors={error?.errors} name="file"/>
            </div>

            {fileToUpload && (
                <>
                    <div className="col-12">
                        {!error && uploading && <ProgressBar now={progress}/>}

                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error.message || 'Failed to upload file!'}
                            </div>
                        )}

                        {fileToUpload &&
                            <AdminItineraryUploadingFile

                                onRemove={() => removeFile()}
                                errors={error?.errors ? error.errors['files.0'] || [] : []}
                                file={fileToUpload}/>
                        }

                    </div>
                    <div className="col-12">
                        <button className="btn btn-primary mr-3"
                                         onClick={() => startUpload()}>Upload</button>

                        <a className="btn btn-secondary" onClick={(e) => cancel()}>Cancel</a>
                    </div>
                </>
            )}
        </div>
    );
}

const AdminItineraryUploadingFile = ({file, errors = [], onRemove, ...props}) => {

    return (
        <>
            <div className="row">
                <div className="col-10">{file.name} ({humanFileSize(file.size)})</div>
                <div className="col-2">
                    <a className="btn" onClick={() => onRemove()}><img src={deleteIcon}/></a>
                </div>
            </div>
            {errors.length > 0 && (
                <div className="row">
                    <div className="col-12">
                        <small className="text-danger">{errors}</small>
                    </div>
                </div>
            )}
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminItineraryFileUploader);
